module.exports = __webpack_public_path__ + "static/media/pa.pictogram.dcc776c9.svg";